// extracted by mini-css-extract-plugin
module.exports = {"attributes":"styles-module__attributes___2BVGJ"};